var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"main-search"},[_c('v-flex')],1),_c('v-layout',{staticClass:"config-menu",staticStyle:{"vertical-align":"baseline !important"}},[_c('v-flex',[_c('configMenu')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }